// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/appvue." + {"296": "4629c546","413": "3f7c37d3","489": "9994931d","506": "fab3e067","624": "ceac2c6d","66": "19e19b1c","714": "9b67707f","722": "1a5fe49d",}[chunkId] + ".js"
}